import { render, staticRenderFns } from "./CardEditorTipTap.vue?vue&type=template&id=16f69748&"
import script from "./CardEditorTipTap.vue?vue&type=script&lang=js&"
export * from "./CardEditorTipTap.vue?vue&type=script&lang=js&"
import style0 from "./CardEditorTipTap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports